/**
 * Video URL parser — supports YouTube, YouTube Shorts and Vimeo.
 * Returns null if the URL is empty or unrecognized.
 */

const YT_ID_RE = /^[a-zA-Z0-9_-]{11}$/;

export function parseVideoUrl(rawUrl) {
  if (!rawUrl || typeof rawUrl !== 'string') return null;
  const url = rawUrl.trim();
  if (!url) return null;

  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }

  const host = (parsed.hostname || '').toLowerCase().replace(/^www\./, '');

  // YouTube variants
  if (['youtube.com', 'm.youtube.com', 'youtube-nocookie.com'].includes(host)) {
    if (parsed.pathname === '/watch') {
      const v = parsed.searchParams.get('v') || '';
      if (YT_ID_RE.test(v)) return { provider: 'youtube', videoId: v, embedUrl: `https://www.youtube.com/embed/${v}` };
    }
    if (parsed.pathname.startsWith('/shorts/')) {
      const v = parsed.pathname.split('/')[2] || '';
      if (YT_ID_RE.test(v)) return { provider: 'youtube', videoId: v, embedUrl: `https://www.youtube.com/embed/${v}` };
    }
    if (parsed.pathname.startsWith('/embed/')) {
      const v = parsed.pathname.split('/')[2] || '';
      if (YT_ID_RE.test(v)) return { provider: 'youtube', videoId: v, embedUrl: `https://www.youtube.com/embed/${v}` };
    }
  }
  if (host === 'youtu.be') {
    const v = parsed.pathname.replace(/^\//, '').split('/')[0];
    if (YT_ID_RE.test(v)) return { provider: 'youtube', videoId: v, embedUrl: `https://www.youtube.com/embed/${v}` };
  }

  // Vimeo — vimeo.com/<id>  or  player.vimeo.com/video/<id>
  if (host === 'vimeo.com' || host === 'player.vimeo.com') {
    const parts = parsed.pathname.split('/').filter(Boolean);
    for (const p of parts) {
      if (/^\d+$/.test(p)) {
        return { provider: 'vimeo', videoId: p, embedUrl: `https://player.vimeo.com/video/${p}` };
      }
    }
  }

  return null;
}
